export const getUniqueValuesFromArray = <T = any>(
  array: T[],
  comparedValue?: keyof T
): T[] => {
  return array.reduce((acc: T[], current: T) => {
    let x: T | undefined

    if (comparedValue) {
      x = acc.find(a => a[comparedValue] === current[comparedValue])
    } else {
      x = acc.find(a => JSON.stringify(a) === JSON.stringify(current))
    }

    if (!x) {
      return [...acc, current]
    }
    return acc
  }, [])
}
